import dayjs from 'dayjs';

import { DailyUniqueIssuesData } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { ScoreData } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';

export const toDateKey = (date: string): string => dayjs(date).format('YYYY-MM-DD');

const EMPTY_DAY = (dateKey: string): DailyUniqueIssuesData => ({
	date: dateKey,
	total: 0,
	critical: 0,
	serious: 0
});

const alignToScoreDates = (
	issuesMap: Map<string, DailyUniqueIssuesData>,
	scoreDates: string[]
): DailyUniqueIssuesData[] =>
	scoreDates.map((dateKey) => issuesMap.get(dateKey) ?? EMPTY_DAY(dateKey));

export interface NormalizedIssues {
	dailyAllIssues: DailyUniqueIssuesData[];
	dailyUniqueIssues: DailyUniqueIssuesData[];
}

export const normalizeIssuesToScoreDates = (
	scores: ScoreData[],
	dailyAllIssues: DailyUniqueIssuesData[],
	dailyUniqueIssues: DailyUniqueIssuesData[]
): NormalizedIssues => {
	const validScoreDates = scores
		.filter((s) => s.score !== null && s.calculation_date)
		.map((s) => toDateKey(s.calculation_date));

	if (!validScoreDates.length) {
		return { dailyAllIssues, dailyUniqueIssues };
	}

	const allIssuesMap = new Map(dailyAllIssues.map((d) => [toDateKey(d.date), d]));
	const uniqueIssuesMap = new Map(dailyUniqueIssues.map((d) => [toDateKey(d.date), d]));

	return {
		dailyAllIssues: alignToScoreDates(allIssuesMap, validScoreDates),
		dailyUniqueIssues: alignToScoreDates(uniqueIssuesMap, validScoreDates)
	};
};
